import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Service from "@/pages/Service";
import ServiceCity from "@/pages/ServiceCity";
import City from "@/pages/City";
import Sitemap from "@/pages/Sitemap";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import { SERVICES, CITIES } from "@/data/config";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

// Route resolver for flat slugs. A single `:slug` catch-all under `/` cannot be
// used because it collides with `/about` etc. Instead we generate explicit
// routes for each slug type from the config.
function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/sitemap.html" element={<Sitemap />} />
            <Route path="/thanks" element={<ThankYou />} />
            {SERVICES.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<Service />} />
            ))}
            {CITIES.map((c) => (
              <Route key={c.slug} path={`/${c.slug}`} element={<City />} />
            ))}
            {SERVICES.flatMap((s) =>
              CITIES.map((c) => (
                <Route
                  key={`${c.slug}-${s.slug}`}
                  path={`/${c.slug}-${s.slug}`}
                  element={<ServiceCity />}
                />
              ))
            )}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
